import { george, pr, theme } from "aaa";
import { withFormsy } from "formsy-react";
import * as React from "react";
import { IFormsyComponentProps } from "./FormsyProps";
import { NativeTextField } from "./NativeTextField";

type IProps = {
    errorMessage?: string,
    decorator?: string,
    isLoading?: boolean,

    label?: string,
    hintText?: string,
    inputStyle?: React.CSSProperties,
    style?: React.CSSProperties,
    inputFrameStyle?: React.CSSProperties,

    // input props
    type?: string,
    inputMode?: string,
    disabled?: boolean,
    id?: string,
    value?: string | number,
    autoComplete?: "on" | "off",
    maxLength?: number,
    multiLine?: boolean,
    rows?: number,
    lineHeight?: number,

    adornment?: React.ReactNode;

    onChange?(event: any, value: string): void,
    onBlur?(): void,
};

const Decorator = (props: { title: string }) => (
    <pr.HFlexCentered
        className="theme-paragraph-color"
        style={{
            fontSize: 18,
            position: "absolute",
            right: 0,
            top: 0,
            height: 50,
            minWidth: 64,
            borderLeft: `1px solid ${theme.customColors.georgeInputFrame}`
        }}
        aria-hidden
    >
        {props.title}
    </pr.HFlexCentered>
);

export const GeorgeTextField = (props: IProps) => {
    // Have to do this, because custom props not allowed on <input>
    const { label, errorMessage, decorator, isLoading, onChange, inputStyle, inputFrameStyle, style, onBlur, ...inputProps } = props;

    const [focus, setFocus] = React.useState(false);

    return (
        <>
            <div style={props.style}>
                <george.InputFrame
                    className={inputProps.disabled ? "theme-textfield-disabled-background-color" : undefined}
                    isLoading={props.isLoading}
                    style={{
                        paddingLeft: 10,
                        paddingRight: 10,
                        boxShadow: focus ? theme.focusShadow : "none",
                        transition: "box-shadow 0.2s",
                        ...inputFrameStyle,
                        ...((inputProps.multiLine || label) ? { height: "unset" } : {})
                    }}
                >
                    {label && <pr.P_12_CONTENT style={{ marginTop: 8 }}>{label}</pr.P_12_CONTENT>}

                    {!props.isLoading &&
                        <NativeTextField
                            {...inputProps}
                            inputStyle={inputStyle}
                            hintText={props.hintText as any}
                            onChange={props.onChange}
                            onFocus={() => setFocus(true)}
                            onBlur={() => {
                                if (onBlur) {
                                    onBlur();
                                }
                                setFocus(false);
                            }}
                        />
                    }
                    {props.decorator && <Decorator title={props.decorator} />}
                    {props.adornment}
                </george.InputFrame >
                {props.errorMessage && <p className="theme-validation-error">{props.errorMessage}</p>}
            </div>
        </>
    );
};

export const GeorgeCenteredTextField = (props: IProps) => (
    <GeorgeTextField {...props} inputStyle={pr.STYLE_CENTERED_TEXT_FIELD} />
);

type TextFieldFormsyProps = IFormsyComponentProps & {
    inputValidations?: (value: string) => boolean | Array<(value: string) => boolean>,
    onChange?: (value: string) => void,
    disabled?: boolean,
    value?: string,
    defaultValue?: string,
    hintText?: string,
    centered?: boolean,
    decorator?: string,
    isLoading?: boolean,
    instantError?: boolean,
    validateEmpty?: boolean,
    type?: string,
    inputMode?: string,
    "aria-label"?: string,
    inputStyle?: React.CSSProperties,
    inputFrameStyle?: React.CSSProperties,
    lineHeight?: number,
    maxLength?: number,
    adornment?: React.ReactNode,
};

class TextFieldFormsy extends React.Component<TextFieldFormsyProps, { showError: boolean }> {
    constructor(props: TextFieldFormsyProps) {
        super(props);
        this.state = { showError: props.instantError === true };
    }

    componentDidMount() {
        if (this.props.defaultValue) {
            // Formsy controls are controlled -> So we have to set the default value into the value
            this.props.setValue(this.props.defaultValue);
        }
    }

    componentDidUpdate(prevProps: TextFieldFormsyProps) {
        if (this.props.instantError !== prevProps.instantError && this.props.instantError === true) {
            this.setState({ showError: true });
        }
    }

    changeValue = (event: any) => {
        if (this.props.inputValidations) {
            if (typeof this.props.inputValidations === "function") {
                if (!this.props.inputValidations(event.currentTarget.value)) {
                    return;
                }
            } else if ((this.props.inputValidations as any) instanceof Array) {
                for (const validator of (this.props.inputValidations as Array<Function>)) {
                    if (!validator(event.currentTarget.value)) {
                        return;
                    }
                }
            }
        }

        const value = event.currentTarget.value;

        if (this.props.onChange) {
            this.props.onChange(value);
        }

        this.setState({ showError: this.props.instantError === true });

        // setValue() will set the value of the component, which in
        // turn will validate it and the rest of the form
        // Important: Don't skip this step. This pattern is required
        // for Formsy to work.
        this.props.setValue(value);
    }

    render() {
        const value = this.props.getValue() || this.props.value || "";

        let errorMessage = "";
        if (typeof this.props.validationError === "function") {
            errorMessage = this.props.validationError(value);
        } else {
            errorMessage = this.props.getErrorMessage();
        }

        let inputStyle = this.props.inputStyle;
        if (!inputStyle) {
            if (this.props.centered) {
                inputStyle = pr.STYLE_CENTERED_TEXT_FIELD;
            }
        }

        const shouldShowError = (this.props.getValue() || this.props.validateEmpty) && this.state.showError;

        return (
            <div>
                <GeorgeTextField
                    id={this.props.name}
                    onChange={this.changeValue}
                    onBlur={() => this.setState({ showError: true })}
                    disabled={this.props.disabled}
                    value={value}
                    hintText={this.props.hintText}
                    errorMessage={shouldShowError ? errorMessage : undefined}
                    inputStyle={inputStyle}
                    decorator={this.props.decorator}
                    isLoading={this.props.isLoading}
                    autoComplete="off"
                    type={this.props.type}
                    inputMode={this.props.inputMode}
                    aria-label={this.props["aria-label"]}
                    maxLength={this.props.maxLength}
                    inputFrameStyle={this.props.inputFrameStyle}
                    lineHeight={this.props.lineHeight}
                    adornment={this.props.adornment}
                />
            </div>
        );
    }
}

export const GeorgeTextFieldFormsy = withFormsy(TextFieldFormsy);



// WEBPACK FOOTER //
// ./src/components/common/GeorgeTextField.tsx